export default "__VITE_ASSET__jpENSDAa__"